import React from 'react'
import styled from 'styled-components'
import { MOBILE } from '../CustomLanding.styled'
import { colors, philosophy } from '../content'

const Philosophy: React.FC = () => (
	<Section>
		<Inner>
			<Title>
				{philosophy.title}
				<span>{philosophy.titleEmoji}</span>
			</Title>
			<P>{philosophy.p1}</P>
			<P last>{philosophy.p2}</P>
			<Grid>
				{philosophy.cards.map(card => (
					<Card key={card.text} dark={card.dark}>
						{card.text}
					</Card>
				))}
			</Grid>
			<Closing>{philosophy.closing}</Closing>
		</Inner>
	</Section>
)

export default Philosophy

const Section = styled.section`
	background: ${colors.paper};
	padding: 64px 0;
	${MOBILE} {
		padding: 40px 0;
	}
`

const Inner = styled.div`
	max-width: 900px;
	margin: 0 auto;
	padding: 0 32px;
	text-align: center;
	${MOBILE} {
		padding: 0 18px;
	}
`

const Title = styled.h2`
	font-weight: 700;
	font-size: clamp(24px, 2.2vw, 34px);
	line-height: 1.35;
	color: ${colors.navy};
	margin: 0 0 16px;
	${MOBILE} {
		font-size: 28px;
		line-height: 1.4;
		margin-bottom: 14px;
	}
`

const P = styled.p<{ last?: boolean }>`
	margin: 0 0 ${p => (p.last ? '24px' : '4px')};
	font-size: 17px;
	line-height: 1.9;
	color: ${colors.body};
	${MOBILE} {
		font-size: 16px;
		line-height: 1.9;
		margin-bottom: ${p => (p.last ? '20px' : '4px')};
	}
`

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
	gap: 16px;
	${MOBILE} {
		grid-template-columns: 1fr 1fr;
		gap: 10px;
	}
`

const Card = styled.div<{ dark: boolean }>`
	background: ${p => (p.dark ? colors.navy : '#ffffff')};
	border: 1px solid ${p => (p.dark ? colors.navy : colors.line)};
	border-radius: 18px;
	padding: 20px 16px;
	font-weight: 700;
	font-size: 18px;
	color: ${p => (p.dark ? colors.amber : colors.navy)};
	${MOBILE} {
		border-radius: 16px;
		padding: 18px 12px;
		font-size: 16px;
	}
`

const Closing = styled.p`
	margin: 24px 0 0;
	font-size: 18px;
	font-weight: 700;
	color: ${colors.navy};
	${MOBILE} {
		margin-top: 20px;
		font-size: 16px;
	}
`
